import 'semantic-ui-css/components/button.min.css';
import 'semantic-ui-css/components/checkbox.min.css';
import 'semantic-ui-css/components/dimmer.min.css';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/loader.min.css';
import 'semantic-ui-css/components/transition.min.css';
import 'semantic-ui-css/components/popup.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@uppy/core/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import 'whatwg-fetch';
import 'abortcontroller-polyfill';
import 'intersection-observer';
import 'trix/dist/trix';
import 'trix/dist/trix.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, HashRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from 'styled-components';

import { concatTrendsFlexFilters } from 'common/utils/locationUtils';
import apolloClient from 'common/utils/apolloClient';
import IntlTranslationsProvider from 'common/components/IntlTranslationsProvider';
import styleTheme from 'common/constants/styleTheme';

import history from 'common/history';
import store from 'common/store';
import Routes from 'common/routes';
import customizeChartTooltips from 'trends/company/initializers';

import PositiveNotification from 'applications/positiveNotification/PositiveNotification';
import ActionsAndKudos from 'actions_and_kudos/containers/actions_and_kudos';
import CoachingSessionModal from 'coaching_notes/CoachingSessionModal';
import { Nav } from 'common/components/Nav/Nav';
import UserActionsSidePanel from 'settings/UserActionsSidePanel';

require('legacy/libs/bootstrap-daterangepicker/daterangepicker.css');

const isTrendsPage = window.location.href.includes('trends');

const Wrapper = ({ children }) => (
  <IntlTranslationsProvider>
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={styleTheme}>
          <Router history={history}>{children}</Router>
        </ThemeProvider>
      </ApolloProvider>
    </Provider>
  </IntlTranslationsProvider>
);
const Spa = () => (
  <Wrapper>
    <Routes />
  </Wrapper>
);
const HeaderNavBar = () => (
  <Wrapper>
    <Nav />
  </Wrapper>
);
const UserSettings = () => (
  <Wrapper>
    <UserActionsSidePanel />
  </Wrapper>
);

const Notifications = () => (
  <Wrapper>
    <PositiveNotification />
  </Wrapper>
);

store.dispatch({
  type: 'INITIALIZATION_DATA',
  data: window.initializationData || {},
});

document.addEventListener('DOMContentLoaded', () => {
  const userSettingsRoot = document.getElementsByClassName('user-settings-header')[0];
  if (userSettingsRoot) {
    ReactDOM.render(<UserSettings />, userSettingsRoot);
  }
  const navBarRoot = document.getElementsByClassName('js-nav-bar')[0];
  if (navBarRoot) {
    ReactDOM.render(<HeaderNavBar />, navBarRoot);
  }
  const spaRoot = document.getElementsByClassName('spa-root')[0];
  if (spaRoot) {
    ReactDOM.render(<Spa />, spaRoot, () => {
      concatTrendsFlexFilters();
      customizeChartTooltips();
    });
  }

  const positiveNotificationRoot = document.getElementsByClassName(
    'js-positive-notification'
  )[0];
  if (positiveNotificationRoot) {
    ReactDOM.render(<Notifications />, positiveNotificationRoot);
  }

  if (!isTrendsPage) {
    const actionsAndKudosRoot = document.getElementsByClassName(
      'actions-and-kudos-container'
    )[0];
    if (actionsAndKudosRoot) {
      ReactDOM.render(<ActionsAndKudos />, actionsAndKudosRoot);
    }
  }

  const legacyCoachingNotesRoot = document.getElementsByClassName(
    'coaching-notes-container'
  )[0];
  if (legacyCoachingNotesRoot) {
    ReactDOM.render(
      <HashRouter>
        <Route path="/coaching-session" component={CoachingSessionModal} />
      </HashRouter>,
      legacyCoachingNotesRoot.appendChild(document.createElement('div'))
    );
  }
});

if (module.hot) {
  module.hot.accept();
}
